<template>
<v-main  v-scroll="onScroll">
  <header-index :logo_background="backgroundUrl" :onTop="onTop" v-on:editContent="editContent"></header-index>
  <v-container class="p-6" fluid>
    <v-container>
      <v-row align="center" justify="center" style="margin-top:75px; margin-bottom:30px;">
        <v-col md="12" style="margin-bottom:20px;">
          <div class="font-back-content" style=" font-size:84px;">Services</div>
          <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('pages.home.services_title')">{{ $vuetify.lang.t('$vuetify.pages.home.services_title') }}</span><br/>
          <span style="color:#414a52; font-weight:700; font-size:38px;" @click="editContent('pages.home.services_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.home.services_subtitle') }}</span>
          <p style="width:50%; margin: 0 auto;" @click="editContent('pages.home.services_description')">
            {{ $vuetify.lang.t('$vuetify.pages.home.services_description') }}</p>
        </v-col>
        <v-col cols="12" md="3" style="text-align:left;" class="single-service">
          <div style="height:60px;"><img src="https://demo.artureanec.com/html/transx/img/road_freight.svg" height="100%" /></div><br/>
          <div class="feature-title" @click="editContent('pages.home.services_1_title')">{{ $vuetify.lang.t('$vuetify.pages.home.services_1_title') }}</div>
          <p class="feature-content" @click="editContent('pages.home.services_1_description')">
            {{$vuetify.lang.t('$vuetify.pages.home.services_1_description') | truncate(120,'...')}}
          </p>
          <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text :to="{name:'singleService', params: {name: 'road-freight'}}" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
        </v-col>
        <v-col cols="12" md="3" style="text-align:left;" class="single-service">
          <div style="height:60px;"><img src="https://demo.artureanec.com/html/transx/img/shipping.svg" height="100%" /></div><br/>
          <div class="feature-title" @click="editContent('pages.home.services_2_title')">{{ $vuetify.lang.t('$vuetify.pages.home.services_2_title') }}</div>
          <p class="feature-content" @click="editContent('pages.home.services_2_description')">
            {{$vuetify.lang.t('$vuetify.pages.home.services_2_description') | truncate(120,'...')}}
          </p>
          <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text :to="{name:'singleService', params: {name: 'ship-freight'}}" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
        </v-col>
        <v-col cols="12" md="3" style="text-align:left;" class="single-service">
          <div style="height:60px;"><img src="https://i.imgur.com/vXLu0Kj.png" height="100%" /></div><br/>
          <div class="feature-title" @click="editContent('pages.home.services_3_title')">{{ $vuetify.lang.t('$vuetify.pages.home.services_3_title') }}</div>
          <p class="feature-content" @click="editContent('pages.home.services_3_description')">
            {{$vuetify.lang.t('$vuetify.pages.home.services_3_description') | truncate(120,'...')}}
          </p>
          <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text :to="{name:'singleService', params: {name: 'air-freight'}}" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
        </v-col>
        <v-col cols="12" md="3" style="text-align:left;" class="single-service">
          <div style="height:60px;"><img src="https://i.imgur.com/iQM2gKl.png" height="100%" /></div><br/>
          <div class="feature-title" @click="editContent('pages.home.services_4_title')">{{ $vuetify.lang.t('$vuetify.pages.home.services_4_title') }}</div>
          <p class="feature-content" @click="editContent('pages.home.services_4_description')">
            {{$vuetify.lang.t('$vuetify.pages.home.services_4_description') | truncate(120,'...')}}
          </p>
          <div class="hoverable"><v-btn rounded color="primary" class="borderable-btn" text :to="{name:'singleService', params: {name: 'sea-freight'}}" dark>{{ $vuetify.lang.t('$vuetify.continue_reading') }}</v-btn></div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
  <v-container fluid>
    <v-container>
      <v-row align="center" justify="center" style="margin-top:75px; height:75%;">
        <v-col cols="12" md="4" class="d-none d-md-block" style="padding-top:0; padding-bottom:0;">
          <img src="../../assets/7P2Erfe.webp" width="150%" />
        </v-col>
        <v-col cols="12" md="8" style="background: #30373f; background-image: url('https://demo.artureanec.com/html/transx/img/testimonials-bg.png'); padding:20px; text-align:left; display: flex;">
          <div style="padding:25px; margin: auto; display: flex-root; align-item:middle;">
            <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:#d8dadf;" @click="editContent('pages.home.about_title')">{{ $vuetify.lang.t('$vuetify.pages.home.about_title') }}</span><br/>
            <span style="color:white; font-weight:700; font-size:38px;"  @click="editContent('pages.home.about_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.home.about_subtitle') }}</span><br/>
            <div style="color: white; line-height:28px; margin-top:20px;">
              <p @click="editContent('pages.home.about_description')">{{ $vuetify.lang.t('$vuetify.pages.home.about_description') | truncate(600,'...') }}</p>
            <v-hover
              v-slot:default="{ hover }"
            >
            <v-btn :class="{ 'on-hover-about': hover }" color="white" class="rounded-0 rounded-br-xl text-right" style="border: 2px solid white; padding: 26px 15px; transition: all .1s ease-in-out; font-weight:700;" to="/about" @click="editContent('pages.home.about_btn')" outlined>{{ $vuetify.lang.t('$vuetify.pages.home.about_btn') }}
              <v-spacer/>
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
            </v-hover>
            </div>
          </div>
          
        </v-col>
      </v-row>
    </v-container>
  </v-container>
  <v-container style="background: #fff; text-align:center; width:75%; margin: 0 auto;" fluid>
    <v-container>
      <img src="https://i.imgur.com/zalY5gY.png" width="80%" />
      <v-row>
        <v-col cols="12" md="4" style="vertical-align: bottom; text-align:center;">
          <span style="font-size:72px; font-weight:700;" @click="editContent('pages.home.widget_1_number')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_1_number') }}</span>
          <span style="font-size:48px; font-weight:700;" @click="editContent('pages.home.widget_1_unit')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_1_unit') }}</span> 
          <br/>
          <span style="font-size:18px; font-weight:700;" @click="editContent('pages.home.widget_1_label')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_1_label') }}</span>
        </v-col>
        <v-col cols="12" md="4" style="vertical-align: bottom; text-align:center;">
          <span style="font-size:72px; font-weight:700;" @click="editContent('pages.home.widget_2_number')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_2_number') }}</span>
          <span style="font-size:48px; font-weight:700;" @click="editContent('pages.home.widget_2_unit')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_2_unit') }}</span> 
          <br/>
          <span style="font-size:18px; font-weight:700;" @click="editContent('pages.home.widget_2_label')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_2_label') }}</span>

        </v-col>
        <v-col cols="12" md="4" style="vertical-align: bottom; text-align:center;">
          <span style="font-size:72px; font-weight:700;" @click="editContent('pages.home.widget_3_number')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_3_number') }}</span>
          <span style="font-size:48px; font-weight:700;" @click="editContent('pages.home.widget_3_unit')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_3_unit') }}</span>
          <br/>
          <span style="font-size:18px; font-weight:700;" @click="editContent('pages.home.widget_3_label')">{{ $vuetify.lang.t('$vuetify.pages.home.widget_3_label') }}</span> 
          
        </v-col>
      </v-row>
    </v-container>
  </v-container>
  <v-container style="background: #f4f6f5; height:auto" fluid>
    <v-container>
      <v-row>
        <v-col md="10" style="text-align:left; margin: 0 auto; margin-top:100px;">
          <div class="font-back-content" style="left:unset; right:unset; font-size:84px;">Features</div>
          <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('pages.home.feature_title')">{{ $vuetify.lang.t('$vuetify.pages.home.feature_title') }}</span><br/>
          <span style="color:#414a52; font-weight:700; font-size:38px;">
            <span @click="editContent('pages.home.feature_subtitle_1')">{{ $vuetify.lang.t('$vuetify.pages.home.feature_subtitle_1') }}</span> <br/> <span @click="editContent('pages.home.feature_subtitle_2')">{{ $vuetify.lang.t('$vuetify.pages.home.feature_subtitle_2') }}</span>
          </span>
        </v-col>
      </v-row> 
      <v-container>
        <v-row style="">
          <v-col cols="12" md="3" style="text-align:left;">
            <img src="https://i.imgur.com/oXPlqGU.png" width="64px" /><br/>
            <div class="feature-title" @click="editContent('pages.home.feature_1_title')">{{ $vuetify.lang.t('$vuetify.pages.home.feature_1_title') }}</div>
            <p class="feature-content" @click="editContent('pages.home.feature_1_description')">
              {{$vuetify.lang.t('$vuetify.pages.home.feature_1_description') | truncate(120,'...')}}
            </p>
          </v-col>
          <v-col cols="12" md="3" style="text-align:left;">
            <img src="https://i.imgur.com/QzgQPw3.png" width="64px" /><br/>
            <div class="feature-title" @click="editContent('pages.home.feature_2_title')">{{ $vuetify.lang.t('$vuetify.pages.home.feature_2_title') }}</div>
            <p class="feature-content" @click="editContent('pages.home.feature_2_description')">
              {{$vuetify.lang.t('$vuetify.pages.home.feature_2_description') | truncate(120,'...')}}
            </p>
          </v-col>
          <v-col cols="12" md="3" style="text-align:left;">
            <img src="https://i.imgur.com/KfM5YQa.png" width="64px" /><br/>
            <div class="feature-title" @click="editContent('pages.home.feature_3_title')">{{ $vuetify.lang.t('$vuetify.pages.home.feature_3_title') }}</div>
            <p class="feature-content" @click="editContent('pages.home.feature_3_description')">
              {{$vuetify.lang.t('$vuetify.pages.home.feature_3_description') | truncate(120,'...')}}
            </p>
          </v-col>
          <v-col cols="12" md="3" style="text-align:left;">
            <img src="https://i.imgur.com/6TJd9ie.png" width="64px" /><br/>
            <div class="feature-title" @click="editContent('pages.home.feature_4_title')">{{ $vuetify.lang.t('$vuetify.pages.home.feature_4_title') }}</div>
            <p class="feature-content" @click="editContent('pages.home.feature_4_description')">
              {{$vuetify.lang.t('$vuetify.pages.home.feature_4_description') | truncate(120,'...')}}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-container>
  <v-container style="padding:0px;" fluid>
    <div style="background: url('https://demo.artureanec.com/html/transx/img/quote-bg.jpg'); background-size:cover; height:fit-content;">
      <v-container>
        <v-row>
          <v-col cols="12" md="6" style="text-align:left; padding-top:40px">
            <div class="back-head" style="left:unset; right:unset; width:fit-content; font-size:84px;">Quotation</div>
          <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:white;" @click="editContent('pages.home.quotation_title')">{{ $vuetify.lang.t('$vuetify.pages.home.quotation_title') }}</span>
          <br/>
          <br/>
          <span style="color:white; font-weight:700; font-size:38px;" @click="editContent('pages.home.quotation_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.home.quotation_subtitle') }}</span><br/>
          <p style="width:85%; color: white; line-height:30px; letter-spacing:2px; font-size:16px;" @click="editContent('pages.home.quotation_description')">{{ $vuetify.lang.t('$vuetify.pages.home.quotation_description') }}</p>
          </v-col>
          <v-col cols="12" md="6">
            <v-card style="border-radius: 0px; box-shadow: 0 0 20px rgba(0,0,0,0.3); padding:15px; text-align: left;">
              <v-row>
                <v-col cols="12" md="12">
                  <span class="text-h5" @click="editContent('pages.home.request_quotation_title')">{{ $vuetify.lang.t('$vuetify.pages.home.request_quotation_title') }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Nom & Prénom"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Nom Societé"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="IncoTerm"
                    :items="['EXWORKS','FOB','FCA','DAP','DDP']"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="Type"
                    :items="['FCL','FTL','LCL','LTL','Aérien']"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Port / Aéroport d'origine"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Port / Aéroport de destination"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Date embarquement"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    label="Type Conteneur"
                    :items="type"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="inflammable"
                    label="Inflammable?"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Poids Brute"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Longueur"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Largeur"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Hauteur"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="gerbable"
                    label="Gerbable?"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  <v-container style="background:#f4f6f5;" fluid>
    <v-container>
      <v-row>
        <v-col cols="12" md="4">
          <div style="width:100%; min-height:170px; text-align:left; padding:0 30px; background: #003d90 url('https://demo.artureanec.com/html/transx/img/contact_background.png') bottom right no-repeat; position: relative; bottom:100px;  background-size: 125px; ">
            <h2 style="color:white;font-weight:700; padding-top:20px;" @click="editContent('pages.home.popup_contact_title')">{{ $vuetify.lang.t('$vuetify.pages.home.popup_contact_title') }}</h2>
            <v-btn dark outlined class="rounded-br-xl rounded-0" to="/contact" right style="margin-top:40px;" @click="editContent('pages.home.popup_contact_btn')">{{ $vuetify.lang.t('$vuetify.pages.home.popup_contact_btn') }}
              
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="2"></v-col>
        <v-col cols="12" md="6">
          <div style="height:110px; background: white; width:100%; position:relative; bottom:60px;" class="pa-4">
            <v-hover
              v-slot:default="{ hover }"
            >
            <v-btn :class="{ 'on-hover': hover }" large color="#1976d2" class="rounded-0 rounded-br-xl text-right" style="border: 2px solid #1976d2; padding: 26px 15px; width: 100%; transition: all .1s ease-in-out; font-weight:700;" outlined @click="editContent('pages.home.quotation_btn')">{{ $vuetify.lang.t('$vuetify.pages.home.quotation_btn') }} 
              <v-spacer/>
              <v-icon>mdi-arrow-collapse-right</v-icon>
            </v-btn>
            </v-hover>
          </div>
        </v-col>
      </v-row>
      </v-container>
    </v-container>
  </v-container>
  <v-container style="padding:0px; background:#f4f6f5;" v-if="false" fluid>
    <v-col md="10" style="text-align:center; margin: 0 auto; margin-top:0;">
        <div class="font-back-content" style="left:87px; font-size:84px;">Partners</div>
        <span style="text-transform:uppercase; letter-spacing: 2px; font-weight: 900; color:gray;" @click="editContent('pages.home.partners_title')">{{ $vuetify.lang.t('$vuetify.pages.home.partners_title') }}</span><br/>
        <span style="color:#414a52; font-weight:700; font-size:38px;" @click="editContent('pages.home.partners_subtitle')">{{ $vuetify.lang.t('$vuetify.pages.home.partners_subtitle') }}</span>
      </v-col>
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_1.png" /></div>
          </v-col>
          <v-col cols="12" md="3"><div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_2.png" /></div></v-col>
          <v-col cols="12" md="3"><div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_3.png" /></div></v-col>
          <v-col cols="12" md="3"><div style="margin:10px; background: white; height:200px; line-height:200px;"><img style="vertical-align:middle;" src="https://demo.artureanec.com/html/transx/img/logo_4.png" /></div></v-col>
        </v-row>
      </v-container>
  </v-container>
  <v-container style="padding: 0px;" fluid>
    <v-container>
      <v-row align="center" style="margin: 48px 0px;">
        <v-col cols="12" md="6">
          <img :src="isoImage" style="width: 100%;" />
        </v-col>
        <v-col cols="12" md="6">
          <div style="width:75%;">
            <div class="font-back-content" style="left:unset; right:unset; font-size:84px;">Certifié</div>
            <p class="text-h3" style="font-weight:700; text-align: left; font-size: 22px; text-transform: uppercase;"  @click="editContent('page.about.certification_title')" >{{ $vuetify.lang.t('$vuetify.page.about.certification_title') }}</p>
            <p style="font-weight:700;  text-align: left; font-size: 18px;" @click="editContent('page.about.certification_subtitle')" >{{ $vuetify.lang.t('$vuetify.page.about.certification_subtitle') }}</p>
            <p @click="editContent('page.about.certification_paragraph')" style=" text-align: left; font-size: 18px;">{{ $vuetify.lang.t('$vuetify.page.about.certification_paragraph') }}</p>
            <img :src="certif" width="240" style="margin: 20px 0px;" />

            <div>
              <v-btn text link href="https://www.certipedia.com/quality_marks/9000022841" target="_blank" @click="editContent('page.about.certification_link')">{{ $vuetify.lang.t('$vuetify.page.about.certification_link') }}</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
  <footer-prime v-on:editContent="editContent"></footer-prime>
</v-main>
</template>

<script>
import headerIndex from "./commons/header_index.two"
import footerPrime from "./commons/footer"
import logo_light from "../../assets/logo_light.png"
import logo_dark from "../../assets/logo_dark.png"

import isoImage from "../../assets/prime.png"
import certif from '../../assets/TR-Testmark_9000022841_EN_CMYK_with-QR-Code.png'

export default {
  name: 'homepage',
  data: () => ({
      type: ['20" ', '40" '],
      inflammable: false,
      gerbable: false,
      backgroundUrl: logo_dark,
      isoImage,
      onTop: true,
      certif
    }),
    mounted(){
      this.onScroll()
    },
    methods: {
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
          this.onTop = true
        }else{
          this.backgroundUrl = logo_dark
          this.onTop = false
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'Accueil'})
      },
      dv (obj, path) {
        return path
          .replace(/\[|\]\.?/g, '.')
          .split('.')
          .filter(s => s)
          .reduce((acc, val) => acc && acc[val], obj);
      },
    },
    components: {
      headerIndex,
      footerPrime
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');

.borderable-btn {
  border:2px solid #1976d2a1;
}
.single-service{
  position:relative;
}
.single-service .hoverable {
  position:absolute;
  width:100%;
  opacity: 0;
  transition: opacity .4s linear .2s;
}
.single-service:hover .hoverable{
  opacity: 1;
}

* {
  font-family: 'Inter', sans-serif;
}
.footer-link:before{
  opacity: 0 !important;
}
.footer-link:hover {
  background: transparent;
  
}
.footer-link {
  color: white !important;
}
.footer-link:after {
  position: absolute;
  min-height:0px;
  height: 2px;
  left: 15px;
  right: 0;
  bottom: 0px;
  content: "";
  background: #2196f3;
  opacity:0;
  transition: all .2s ease-in-out;
  width:0;
}
.footer-link:hover:after{
  opacity: 1;
  width:35px;
  
}
.on-hover {
  background: #1976d2;
  color: white!important;
}
.on-hover-about {
  color: #515151 !important;
  background: white;
}
.footer-list p {
  margin-bottom: 10px;
  color: #e8edf4;
  font-size: 14px;
  letter-spacing: 0px;
}
.footer-list p b{
  color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 0px;
  font-size: 18px;
  font-weight: 700;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  pointer-events: none;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  left:0;
  right:0;
  pointer-events: none;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/default.vue